import { render, staticRenderFns } from "./FinanceTransaction.vue?vue&type=template&id=63e21f6e&scoped=true"
import script from "./FinanceTransaction.vue?vue&type=script&lang=js"
export * from "./FinanceTransaction.vue?vue&type=script&lang=js"
import style0 from "./FinanceTransaction.vue?vue&type=style&index=0&id=63e21f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e21f6e",
  null
  
)

export default component.exports